import { Country } from 'src/types/country';
import { MilestoneType } from 'src/types/milestone.types';
import { LessonSubject } from 'src/types/lesson.types';
import { ShowcasedBadge } from 'src/types/badge.types';

export enum UserType {
  parent = 'parent',
  child = 'child',
}

export enum SchoolGroup {
  Primaire = 'primaire',
  College = 'college',
  Lycee = 'lycee',
  Primary = 'primary',
  Secondary = 'secondary',
  Primaria = 'primaria',
  Secundaria = 'secundaria',
  Bachillerato = 'bachillerato',
  Elementaire = 'elementaire',
  Secondaire = 'secondaire',
  Fundamental = 'fundamental',
  Medio = 'medio',
  EnsinoBasico = 'ensino_basico',
  EnsinoSecundario = 'ensino_secundario',
  Primaire_CH = 'primaire_ch',
  SecondaireI = 'secondaire_i',
  SecondaireII = 'secondaire_ii',
  Primary_IN = 'primary_in',
  MiddleSchool_IN = 'middle_school_in',
  Secondary_IN = 'secondary_in',
  SeniorSecondary_IN = 'senior_secondary_in',
  Primaria_IT = 'primaria_it',
  PrimoGrado_IT = 'primo_grado_it',
  SecondoGrado_IT = 'secondo_grado_it',
  Grundschule_DE = 'grundschule_de',
  Hauptschule_DE = 'hauptschule_de',
  Realschule_DE = 'realschule_de',
  Gymnasium_DE = 'gymnasium_de',
  Gesamtschule_DE = 'gesamtschule_de',
  Volksschule_AT = 'volksschule_at',
  Mittelschule_AT = 'mittelschule_at',
  AHSUnterstufe_AT = 'ahs_unterstufe_at',
  AHSOberstufe_AT = 'ahs_oberstufe_at',
  BHS_AT = 'bhs_at',
  BMS_AT = 'bms_at',
}

export enum SchoolLevel {
  CM1 = 'CM1',
  CM2 = 'CM2',
  Sixieme = '6ème',
  Cinquieme = '5ème',
  Quatrieme = '4ème',
  Troisieme = '3ème',
  Seconde = 'Seconde',
  Premiere = 'Première',
  Terminale = 'Terminale',

  Year5 = 'Year 5',
  Year6 = 'Year 6',
  Year7 = 'Year 7',
  Year8 = 'Year 8',
  Year9 = 'Year 9',
  Year10 = 'Year 10',
  Year11 = 'Year 11',
  Year12 = 'Year 12',
  Year13 = 'Year 13',

  Grade4 = 'Grade 4',
  Grade5 = 'Grade 5',
  Grade6 = 'Grade 6',
  Grade7 = 'Grade 7',
  Grade8 = 'Grade 8',
  Grade9 = 'Grade 9',
  Grade10 = 'Grade 10',
  Grade11 = 'Grade 11',
  Grade12 = 'Grade 12',

  Cuarto = '4º Primaria',
  Quinto = '5º Primaria',
  Sexto = '6º Primaria',
  PrimeroESO = '1º ESO',
  SegundoESO = '2º ESO',
  TerceroESO = '3º ESO',
  CuartoESO = '4º ESO',
  PrimeroBach = '1º Bachillerato',
  SegundoBach = '2º Bachillerato',

  Quatrieme_BE = '4ème',
  Cinquieme_BE = '5ème',
  Sixieme_BE = '6ème',
  Premiere_Sec_BE = '1ère_sec',
  Deuxieme_Sec_BE = '2ème_sec',
  Troisieme_Sec_BE = '3ème_sec',
  Quatrieme_Sec_BE = '4ème_sec',
  Cinquieme_Sec_BE = '5ème_sec',
  Rheto = 'Rhéto',

  Quarto_Fund = '4º Ano',
  Quinto_Fund = '5º Ano',
  Sexto_Fund = '6º Ano',
  Setimo_Fund = '7º Ano',
  Oitavo_Fund = '8º Ano',
  Nono_Fund = '9º Ano',
  Primeiro_Medio = '1º Ano EM',
  Segundo_Medio = '2º Ano EM',
  Terceiro_Medio = '3º Ano EM',

  Year4_AU = 'Year 4',
  Year5_AU = 'Year 5',
  Year6_AU = 'Year 6',
  Year7_AU = 'Year 7',
  Year8_AU = 'Year 8',
  Year9_AU = 'Year 9',
  Year10_AU = 'Year 10',
  Year11_AU = 'Year 11',
  Year12_AU = 'Year 12',

  Sixieme_CH = '6ème_CH',
  Septieme_CH = '7ème_CH',
  Huitieme_CH = '8ème_CH',
  Neuvieme_CH = '9ème_CH',
  Dixieme_CH = '10ème_CH',
  Onzieme_CH = '11ème_CH',
  Douzieme_CH = '12ème_CH',
  Treizieme_CH = '13ème_CH',
  Quatorzieme_CH = '14ème_CH',

  Class4_IN = 'Class 4',
  Class5_IN = 'Class 5',
  Class6_IN = 'Class 6',
  Class7_IN = 'Class 7',
  Class8_IN = 'Class 8',
  Class9_IN = 'Class 9',
  Class10_IN = 'Class 10',
  Class11_IN = 'Class 11',
  Class12_IN = 'Class 12',

  QuartaElementare = 'Quarta elementare',
  QuintaElementare = 'Quinta elementare',
  PrimaMedia = 'Prima media',
  SecondaMedia = 'Seconda media',
  TerzaMedia = 'Terza media',
  PrimaSuperiore = 'Prima superiore',
  SecondaSuperiore = 'Seconda superiore',
  TerzaSuperiore = 'Terza superiore',
  QuartaSuperiore = 'Quarta superiore',
  QuintaSuperiore = 'Quinta superiore',

  Grundschule_Klasse3_DE = 'grundschule_klasse3_de',
  Grundschule_Klasse4_DE = 'grundschule_klasse4_de',
  Hauptschule_Klasse5_DE = 'hauptschule_klasse5_de',
  Hauptschule_Klasse6_DE = 'hauptschule_klasse6_de',
  Hauptschule_Klasse7_DE = 'hauptschule_klasse7_de',
  Hauptschule_Klasse8_DE = 'hauptschule_klasse8_de',
  Hauptschule_Klasse9_DE = 'hauptschule_klasse9_de',
  Realschule_Klasse5_DE = 'realschule_klasse5_de',
  Realschule_Klasse6_DE = 'realschule_klasse6_de',
  Realschule_Klasse7_DE = 'realschule_klasse7_de',
  Realschule_Klasse8_DE = 'realschule_klasse8_de',
  Realschule_Klasse9_DE = 'realschule_klasse9_de',
  Realschule_Klasse10_DE = 'realschule_klasse10_de',
  Gymnasium_Klasse5_DE = 'gymnasium_klasse5_de',
  Gymnasium_Klasse6_DE = 'gymnasium_klasse6_de',
  Gymnasium_Klasse7_DE = 'gymnasium_klasse7_de',
  Gymnasium_Klasse8_DE = 'gymnasium_klasse8_de',
  Gymnasium_Klasse9_DE = 'gymnasium_klasse9_de',
  Gymnasium_Klasse10_DE = 'gymnasium_klasse10_de',
  Gymnasium_Klasse11_DE = 'gymnasium_klasse11_de',
  Gymnasium_Klasse12_DE = 'gymnasium_klasse12_de',
  Gymnasium_Klasse13_DE = 'gymnasium_klasse13_de',
  Gesamtschule_Klasse5_DE = 'gesamtschule_klasse5_de',
  Gesamtschule_Klasse6_DE = 'gesamtschule_klasse6_de',
  Gesamtschule_Klasse7_DE = 'gesamtschule_klasse7_de',
  Gesamtschule_Klasse8_DE = 'gesamtschule_klasse8_de',
  Gesamtschule_Klasse9_DE = 'gesamtschule_klasse9_de',
  Gesamtschule_Klasse10_DE = 'gesamtschule_klasse10_de',
  Gesamtschule_Klasse11_DE = 'gesamtschule_klasse11_de',
  Gesamtschule_Klasse12_DE = 'gesamtschule_klasse12_de',
  Gesamtschule_Klasse13_DE = 'gesamtschule_klasse13_de',

  Volksschule_Klasse3_AT = 'volksschule_klasse3_at',
  Volksschule_Klasse4_AT = 'volksschule_klasse4_at',
  Mittelschule_Klasse5_AT = 'mittelschule_klasse5_at',
  Mittelschule_Klasse6_AT = 'mittelschule_klasse6_at',
  Mittelschule_Klasse7_AT = 'mittelschule_klasse7_at',
  Mittelschule_Klasse8_AT = 'mittelschule_klasse8_at',
  AHSUnterstufe_Klasse5_AT = 'ahs_unterstufe_klasse5_at',
  AHSUnterstufe_Klasse6_AT = 'ahs_unterstufe_klasse6_at',
  AHSUnterstufe_Klasse7_AT = 'ahs_unterstufe_klasse7_at',
  AHSUnterstufe_Klasse8_AT = 'ahs_unterstufe_klasse8_at',
  AHSOberstufe_Klasse9_AT = 'ahs_oberstufe_klasse9_at',
  AHSOberstufe_Klasse10_AT = 'ahs_oberstufe_klasse10_at',
  AHSOberstufe_Klasse11_AT = 'ahs_oberstufe_klasse11_at',
  AHSOberstufe_Klasse12_AT = 'ahs_oberstufe_klasse12_at',
  BHS_Klasse9_AT = 'bhs_klasse9_at',
  BHS_Klasse10_AT = 'bhs_klasse10_at',
  BHS_Klasse11_AT = 'bhs_klasse11_at',
  BHS_Klasse12_AT = 'bhs_klasse12_at',
  BHS_Klasse13_AT = 'bhs_klasse13_at',
  BMS_Klasse9_AT = 'bms_klasse9_at',
  BMS_Klasse10_AT = 'bms_klasse10_at',
  BMS_Klasse11_AT = 'bms_klasse11_at',
  BMS_Klasse12_AT = 'bms_klasse12_at',

  Other = 'other',
}

export enum UserFamilyMemberType {
  mother = 'mother',
  father = 'father',
  boy = 'boy',
  girl = 'girl',
  other = 'other',
}

export type ChildMemberType =
  | UserFamilyMemberType.boy
  | UserFamilyMemberType.girl
  | UserFamilyMemberType.other;

export type Family = {
  id: number;
  join_code: string;
  name: string;
  created_at: string;
  updated_at: string;
  premium_ends_at?: string;
  trial_ends_at?: string;
  trial_started_at?: string;
};

export type User = {
  id: number;
  uuid: string;
  family_id: number;
  user_type: UserType | null;
  language: string;
  timezone?: string;
  card_count: number;
  lessons_count: number;
  family_first_lesson_at?: number | null;
  country?: Country;
  firstname?: string;
  lastname?: string;
  pseudo?: string;
  date_of_birth?: string;
  school_level: SchoolLevel | null;
  education_level_code?: string;
  school_id?: number;
  email?: string;
  phone_number?: string;
  family_member_type: UserFamilyMemberType | null;
  onboarding_completed: boolean;
  objectives: string[];
  // `null` = never personalized (legacy user, full catalog); non-empty array = explicit selection;
  // `undefined` only before the user object loads.
  subjects?: LessonSubject[] | null;
  created_at?: string;
  updated_at?: string;
  trial_started_at?: string;
  trial_ends_at?: string;
  show_invite_card: boolean;
  referral_code?: string;
  reffered_by_id?: number;
  family: Family;
  avatar?: Avatar;
  current_streak?: number;
};

export type Avatar = {
  uuid: string;
  url?: string;
  type: string;
};

export type UserAvatarResponse = {
  id: number;
  uuid: string;
  gender?: string;
  animal?: string;
  accessory?: string;
  emotion?: string;
  url?: string;
  type: string;
  created_at: string;
};

export type UserToCreate = Omit<User, 'id' | 'uuid' | 'family_id'>;

export type Child = Omit<User, 'user_type'> & {
  user_type: UserType.child;
};

export type UserActivity = {
  id: number;
  user_id: number;
  type: string;
  babz: number;
  params: {
    [key: string]: unknown;
  };
  created_at: string;
  updated_at: string;
};

export enum MateStatus {
  INVITATION = 'INVITATION',
  FRIENDSHIP = 'FRIENDSHIP',
  BLOCKED = 'BLOCKED',
  UNFRIENDED = 'UNFRIENDED',
}

export type Mate = {
  id: number;
  a_user_id: number;
  b_user_id: number;
  status: MateStatus;
  created_at: string;
  updated_at: string;
  status_updated_by_user_id: number;
  user: {
    id: number;
    uuid: string;
    pseudo: string;
    avatar?: Avatar;
    poke?: PokeForMate;
    latest_heartbeat?: {};
    showcased_badges?: ShowcasedBadge[];
    daily_streaks?: number;
  };
};

export type MateInviteRequest = {
  invited_user_uuid: string;
};

export type MateUpdateRequest = {
  status: MateStatus;
};

export type UserProfile = {
  avatar?: Avatar;
  id: number;
  latest_heartbeat: {};
  latest_poke?: Poke;
  pseudo: string;
  uuid: string;
  babz: number;
  card_count?: number;
  mate?: Omit<Mate, 'user'>;
  milestones: Record<MilestoneType, number>;
  showcased_badges: ShowcasedBadge[];
};

export type Poke = {
  id: number;
  created_at: string;
  uuid: string;
  poke_read_at?: string | null;
};

type PokeForMate = {
  id: number;
  uuid: string;
  origin_user_id: number;
  target_user_id: number;
  notification_id: number;
  poked_at: string;
  poke_read_at?: string;
};

export type RefereeCountResponse = {
  count: number;
};

export type FamilyMemberResponse = {
  family_member_type?: UserFamilyMemberType | null;
  firstname?: string | null;
  id: number;
  name?: string | null;
  user_type?: UserType | null;
  uuid: string;
};

export type FamilyVerifyRequest = {
  join_code: string;
};

export type FamilyVerifyResponse = {
  exists: boolean;
  id?: number | null;
  members?: FamilyMemberResponse[];
  name: string;
};

export type JoinFamilyRequest = {
  join_code: string;
  user_id: number;
};

export type JoinFamilyResponse = {
  custom_token: string;
  firebase_id: string;
};

export type CreateProfileRequest = {
  firstname?: string | null;
  join_code: string;
  user_type: UserType;
};

export type CreateProfileResponse = {
  custom_token: string;
  firebase_id: string;
  user_id: number;
};
